// Casos abiertos por nivel + carril.
import React from 'react';
import { nivelInfo, carrilInfo } from '../../../lib/dashboardVocab';

const CARRILES = ['convivencia_preventiva', 'clinico_orientacion', 'crisis'];
const NIVELES  = ['verde', 'amarillo', 'naranjo', 'rojo'];

export default function OpenCasesGrid({ grid = [], total, loading }) {
  const cell = (carril, nivel) => grid.find((g) => g.carril === carril && g.nivel_alerta === nivel)?.n || 0;

  return (
    <section
      aria-label="Casos abiertos por nivel y carril"
      className="bg-white rounded-2xl border border-[#E5EAF5] p-5"
      data-testid="open-cases-grid"
    >
      <header className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="font-extrabold text-[#0B1B5E]">Casos abiertos por nivel</h2>
          <p className="text-xs text-[#475472]">Distribución por carril y color.</p>
        </div>
        <div className="text-2xl font-extrabold text-[#0B1B5E]" data-testid="open-cases-total">
          {loading ? '…' : (total || 0)}
        </div>
      </header>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm" data-testid="open-cases-table">
          <thead>
            <tr>
              <th className="text-left text-[11px] text-[#475472] font-bold py-2 pr-3">Carril</th>
              {NIVELES.map((n) => {
                const info = nivelInfo(n);
                return (
                  <th key={n} className="text-center text-[11px] font-bold py-2 px-2">
                    <span
                      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full"
                      style={{ background: info.bg, color: info.fg }}
                    >
                      <span className="w-1.5 h-1.5 rounded-full" style={{ background: info.dot }} />
                      {info.label}
                    </span>
                  </th>
                );
              })}
              <th className="text-right text-[11px] text-[#475472] font-bold py-2 pl-3">Total</th>
            </tr>
          </thead>
          <tbody>
            {CARRILES.map((carril) => {
              const info = carrilInfo(carril);
              const totalRow = NIVELES.reduce((acc, n) => acc + cell(carril, n), 0);
              return (
                <tr key={carril} className="border-t border-[#F1F3F9]">
                  <td className="py-2.5 pr-3">
                    <span
                      className="inline-block px-2 py-0.5 rounded-full text-[11px] font-bold"
                      style={{ background: info.bg, color: info.fg }}
                    >
                      {info.label}
                    </span>
                  </td>
                  {NIVELES.map((n) => (
                    <td key={n} className="text-center py-2.5 px-2 text-[#0B1B5E] font-bold" data-testid={`cell-${carril}-${n}`}>
                      {cell(carril, n) || <span className="text-[#CBD5E1]">·</span>}
                    </td>
                  ))}
                  <td className="text-right py-2.5 pl-3 text-[#0B1B5E] font-extrabold">{totalRow || 0}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
